import type { MouseEventHandler, ReactNode } from 'react';
import type { ModalData } from '../Modal';

export interface FiltersWithModalData {
  modal: ModalData;
  canReset: boolean;
  loading: boolean;

  onShowClick?: MouseEventHandler;
  onResetClick?: MouseEventHandler;
}

export interface FiltersWithModalProps extends FiltersWithModalData {
  children: ReactNode;
}
